<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'app',
  mounted () {
    // 禁用双击缩放，优化移动端体验
    document.addEventListener('touchstart', function(event) {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    }, { passive: false });
    
    // 禁止页面缩放
    document.addEventListener('gesturestart', function(event) {
      event.preventDefault();
    });
  },
}
</script>
<style>
/* 全局样式重置 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 16px; /* 调整为更适合手机的字体大小 */
  background-color: #f8f8f8;
  min-height: 100vh;
  overflow-x: hidden;
}

/* 响应式设计基础 */
@media screen and (max-width: 768px) {
  #app {
    font-size: 15px;
  }
}

@media screen and (max-width: 375px) {
  #app {
    font-size: 14px;
  }
}

/* 滚动条美化 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 防止内容被底部安全区域遮挡 */
.safe-area-bottom {
  padding-bottom: env(safe-area-inset-bottom, 0);
}

/* 防止内容被顶部状态栏遮挡 */
.safe-area-top {
  padding-top: env(safe-area-inset-top, 0);
}
</style>
